'use strict';

const initOzone = () => {
	window.ozoneWrapper = window.ozoneWrapper || {};
	window.ozoneWrapper.cmd = window.ozoneWrapper.cmd || [];
};

export default {
	onInit: (data) => {
		initOzone();
		data.onCompleteCallback();
	}
}